// src/utils/ExportService.js
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const exportToPdf = (data, fileName, columns) => {
    const doc = new jsPDF('p', 'pt', 'a4');
    autoTable(doc, {
        columns: columns,
        body: data,
        startY: 70,
        margin: { top: 70, bottom: 40, left: 30, right: 30 },
        styles: { fontSize: 10, cellPadding: 6 },
        headStyles: { fillColor: [41, 128, 185], textColor: 255 },
        alternateRowStyles: { fillColor: [245, 249, 252] },
        didDrawPage: (data) => {
            const pageSize = doc.internal.pageSize;
            const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
            const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            // Border
            doc.setDrawColor(41, 128, 185);
            doc.setLineWidth(1.5);
            doc.rect(20, 20, pageWidth - 40, pageHeight - 40);

            // Header
            doc.setFontSize(18);
            doc.setTextColor(40);
            doc.text(fileName.replace(/_/g, ' '), 30, 45);

            // Footer
            doc.setFontSize(9);
            doc.setTextColor(100);
            doc.text(`Generated: ${new Date().toLocaleDateString()}`, 30, pageHeight - 30);
            doc.text(`Page ${doc.internal.getNumberOfPages()}`, pageWidth - 70, pageHeight - 30);
        }
    });

    doc.save(`${fileName}_${new Date().getTime()}.pdf`);
};

export const exportToExcel = (data, fileName) => {
    import('xlsx').then((xlsx) => {
        const worksheet = xlsx.utils.json_to_sheet(data);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });

        saveAsExcelFile(excelBuffer, fileName);
    });
};

// Helper function to handle the File-Saver logic
const saveAsExcelFile = (buffer, fileName) => {
    import('file-saver').then((module) => {
        if (module && module.default) {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            // FIXED: Changed 'buffer' to match the parameter name
            const blobData = new Blob([buffer], { type: EXCEL_TYPE });
            module.default.saveAs(blobData, `${fileName}_${new Date().getTime()}.xlsx`);
        }
    });
};
